import { render, staticRenderFns } from "./logdetails.vue?vue&type=template&id=504353d8&scoped=true&"
import script from "./logdetails.vue?vue&type=script&lang=js&"
export * from "./logdetails.vue?vue&type=script&lang=js&"
import style0 from "./logdetails.vue?vue&type=style&index=0&id=504353d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504353d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('504353d8')) {
      api.createRecord('504353d8', component.options)
    } else {
      api.reload('504353d8', component.options)
    }
    module.hot.accept("./logdetails.vue?vue&type=template&id=504353d8&scoped=true&", function () {
      api.rerender('504353d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/logistics/logdetails.vue"
export default component.exports